import { render } from "./v-spinner.vue?vue&type=template&id=02d55311&scoped=true"
import script from "./v-spinner.vue?vue&type=script&lang=js"
export * from "./v-spinner.vue?vue&type=script&lang=js"

import "./v-spinner.vue?vue&type=style&index=0&id=02d55311&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d55311"]])

export default __exports__